/* unplugin-vue-components disabled */import { render } from "./AvatarImage.vue?vue&type=template&id=0e21e362&ts=true"
import script from "./AvatarImage.vue?vue&type=script&lang=ts"
export * from "./AvatarImage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__